import React, { useState } from 'react';
import Modal from 'react-modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom'; // Add this import
import AgreementApiService from '../../ApiServices/SettingApiServices/AgreementApiService';

// Set custom styles for the modal
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        padding: '0',
        borderRadius: '8px',
        boxShadow: '0 8px 30px rgba(0, 0, 0, 0.2)',
        backgroundColor: '#f9f9f9',
        width: '500px',
    },
};

const TaxInfoForm = () => {

    const [formData, setFormData] = useState({
         
        FirstName: '',
        LastName:  '',
        Company:  '',
        PhoneNumber: ''
    });
     
     

    const [loading, setLoading] = useState(false);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleDownload = () => {
      // File ka path specify karein
      const filePath = "/ADSPACE TAX FORM 2025.pdf";
      const link = document.createElement("a");
      link.href = filePath;
      const year = new Date();
      link.download = `ADSPACE TAX FORM ${year.getFullYear()}.pdf`; // File ka naam specify karein
      document.body.appendChild(link);
      link.click();
      link.remove();
    };

     
    return (
        <>
            <ToastContainer />
            
           
            <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-aos="fade-up">
                <h2 className="text-xl font-semibold mb-4">Manage Tax Information</h2>
                <p className="mb-4 text-gray-600">
                  This information is needed to confirm whether you are a US or non-US taxpayer and whether we are required to withhold taxes from your income. 
                  
                </p>
                {/* <p> Add your tax information now to avoid delays in receiving payments. </p>
                 <div className="mb-4 text-red-600">❌ No Tax Information found</div>
                <button
                  className="flex items-center justify-center text-red-500 border border-red-500 hover:bg-red-500 hover:text-white transition-colors duration-300 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2"
                >
                  Add Tax Info
                </button> */}

                {/* <div className="mb-4 text-red-600">❌ No Tax Information found</div> */}
                <button onClick={handleDownload}
                  className="flex items-center justify-center text-red-500 border border-red-500 hover:bg-red-500 hover:text-white transition-colors duration-300 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2"
                >
                  Download Tax Info
                </button>
              </div>
        
        </>
    );
};

export default TaxInfoForm;
